module.exports = __webpack_public_path__ + "assets/img/fish-head.3aa3c8eb.png";